export default "__VITE_ASSET__BGbp1nRR__"